import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { getAllowedAttributes } from '../../props-filters';

var Actions = function Actions(_ref) {
  var children = _ref.children,
      slot = _ref.slot,
      restProps = _objectWithoutProperties(_ref, ['children', 'slot']);

  return React.createElement(
    'div',
    getAllowedAttributes(restProps),
    children
  );
};

Actions.propTypes = {
  children: PropTypes.node,
  slot: PropTypes.oneOf(['actions'])
};

export default Actions;
//# sourceMappingURL=Actions.js.map